// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"campaign-start_spinner-container__11nMS","container":"campaign-start_container__1sHoz","campaign__description":"campaign-start_campaign__description__YnQZX"};